const baseUrl = 'https://d2vluxb694imb6.cloudfront.net/dev/maruti';

export const environment = {
  production: false,
  BASE_URL: `${baseUrl}`,
  COMM_BASE_URL: `${baseUrl}/communication-service/v1/`,
  FORM_BASE_URL: `${baseUrl}/form/v1/`,
  CAMPAIGN_BASE_URL: `${baseUrl}/campaign/v1/`,
  ESB_BASE_URL: `${baseUrl}/esb-service/`,
  COMPOSITE_BASE_URL: `${baseUrl}/composite/v1/`,
  REPORTING_BASE_URL: `${baseUrl}/reporting-service/v1/`,
  URL_SHORTEN_BASE_URL: `${baseUrl}/url-shorten/v1/`,
  REPORTING_URL: `${baseUrl}/reporting/v1/`,
  REDIRECT_URL: 'https://dev.campaign.communicationmanager.in/dashboard',
  LOGOUT_URL: 'https://dev.campaign.communicationmanager.in/login',
  FORM_PREVIEW_URL: 'https://dev.formsmarutisuzuki.com',
  QLIK_SENSE_REPORT_URL: 'https://dev-reports.communicationmanager.in',
  FORM_DEFAULT_LOGO_URL:
    'https://d1fcy6e4845263.cloudfront.net/logos/LogoMSIL-20240701-0636241-main.png',
  INHOUSE_SHORTENING_URL: 'https://dev.msillink.com/MARUTI/',
};
